export default {
	data() {
		return {
			keywords: '',
		}
	},
	methods: {
		setKeywords(value) {
			this.keywords = value
		},
		search() {
			if (this.paginate_to) {
				this.paginate_to(1)
			}
		},
	},

	computed: {},
}
